import React, { Component } from 'react';
import { Icon, Segment, Table, Dropdown, Container, Button, Checkbox } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { withTranslation } from 'react-i18next';
import 'moment/locale/tr';

class Analytic extends Component {
	state = {
		filterType: false,
		filterAgent: false,
		loading: true,
		start_date: this.props.start_date,
		end_date: this.props.end_date,
		today: moment(),
		group: ['agent'],
		value: [5, 4, 3, 2, 1],
		agent_role: this.props.access.user.loggedUserObj.role,
		agent_id: this.props.access.user.loggedUserObj.extra.user_id,
		pid: /* '02cc63330cd0808f87c54ad9dd94b74a' ||  */ this.props.product.live.settings.live.token,
		selectedAgent: 'all',
		selectedDate: 'daily',
		groupBy: 'agent',
		selectedTopic: 'all',
		column: 'rate',
		botId: '',
		direction: 'descending',
		dataloading: true,
		displayName: 'developer',
		selectedBarStyle: 'line',
		loadingGraph: true,
		rate: 'all',
		selectedPlatform: 'all',
		selectedWatsonsGroup: 'all',
		selectedTeam: 'all',
	};
	componentDidMount() {
		this.getData();
	}
	componentDidUpdate(oldProps, oldState) {
		const check_list = [
			/* 'start_date', 'end_date',  */ 'selectedAgent',
			'value',
			'selectedPlatform',
			'selectedWatsonsGroup',
			'newDataToggle',
			'selectedTeam',
		];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			if (key === 'start_date' || key === 'end_date' || key === 'newDataToggle') {
				if (this.props[key] !== oldProps[key]) {
					this.getData();
					break;
				}
			}
			if (this.state[key] !== oldState[key]) {
				this.getData();
				break;
			}
		}
	}
	async getData() {
		this.setState({ loading: true });
		let { pid, selectedAgent, selectedPlatform, selectedWatsonsGroup, productAgentList, selectedTeam } = this.state;
		let { start_date, end_date, product } = this.props;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let filter = {};
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList;
		}
		if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
			if (selectedTeam !== 'all') {
				showingproductAgentList2 = _.filter(productAgentList, (it) => it.team === selectedTeam);
			} else {
				showingproductAgentList2 = productAgentList;
			}
		}
		console.log('showingproductAgentList2', showingproductAgentList2);
		let group_agents = _.map(showingproductAgentList2, (it) => it.id);
		if (selectedAgent === 'all') {
			if (selectedWatsonsGroup !== 'all') {
				filter = { type: ['closed'], pid, agent: group_agents };
			} else {
				filter = { type: ['closed'], pid };
			}
			if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
				if (selectedTeam !== 'all') {
					filter = { type: ['closed'], pid, agent: group_agents };
				} else {
					filter = { type: ['closed'], pid };
				}
			}
		} else {
			filter = { type: ['closed'], pid, agent: selectedAgent };
		}
		if (selectedPlatform !== 'all') {
			if (pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && selectedPlatform === 'web') {
				_.set(filter, 'platform', ['web', 'flo']);
			} else {
				_.set(filter, 'platform', selectedPlatform);
			}
		}
		await fetch('/api/dahi/message/getLiveChat', {})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					productAgentList:
						data.result &&
						data.result.agents &&
						_.filter(data.result.agents, function (it) {
							return it.type !== 'viewer';
						}),
					botId: data.result && data.result.bot.bid,
					bot_id: data.result && data.result.bot.id,
					staticOptions: data.result && data.result.staticOptions,
					productOldAgentList: data.result && data.result.old_agents,
					closeTags: data.result && data.result.staticOptions && data.result.staticOptions.closeTags,
					chat_groups: data.result && data.result.staticOptions && data.result.staticOptions.groups,
					chat_teams: data.result && data.result.staticOptions && data.result.staticOptions.teams,
				});
			});
		let livechat_agent = _.find(this.state.productAgentList, (it) => it.id === this.props.access.user.loggedUserObj.extra.user_id);
		if (livechat_agent && livechat_agent.team && !livechat_agent.team_admin) {
			let showingproductAgentList2;
			if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
				showingproductAgentList2 = _.filter(this.state.productAgentList, (it) => it.team === livechat_agent.team);
				let group_agents = _.map(showingproductAgentList2, (it) => it.id);
				console.log('group_agents', group_agents);
				filter = { type: ['closed'], pid, agent: group_agents };
			}
		}
		fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter,
				select: [],
				group: ['type', 'agent', 'rate', 'cid', 'date', 'platform', 'topic', 'comment', 'selectable_comment'],
				pairs: {
					agent: 'select1',
					topic: 'select2',
					select1: 'select1',
					cid: 'select4',
					rate: 'select5',
					platform: 'platform',
					comment: 'select7',
					selectable_comment: 'select3',
				},
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let list = _.filter(data.result, (o) => o.rate);
				let modify_list = _.map(list, (it) => {
					it.platform = pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && it.platform === 'web' ? 'flo' : it.platform;
					return it;
				});
				this.setState({ list: modify_list, loading: false });
			});
	}
	handleFilterChange = (e, { text, value }) => this.setState({ selectedAgent: value, selectedAgentName: text });
	handleFilterChangeRate = (e, { text, value }) => this.setState({ rate: value });
	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleFilterCheck(value) {
		let array = this.state.value || [];
		let exists = _.includes(array, value);
		let valueArr = exists ? _.filter(array, (it) => it !== value) : _.concat([], array, value);
		this.setState({ value: valueArr });
	}
	handleSort = (clickedColumn) => () => {
		const { column, direction } = this.state;
		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				direction: 'descending',
			});

			return;
		}
		this.setState({
			direction: direction === 'ascending' ? 'descending' : 'ascending',
		});
	};
	render() {
		let { t, displayName, platformList, product } = this.props;
		let {
			loading,
			list,
			value,
			closeTags,
			search_text,
			column,
			direction,
			selectedPlatform,
			pid,
			productOldAgentList,
			selectedWatsonsGroup,
			chat_groups,
			chat_teams,
			selectedTeam,
		} = this.state;
		let productAgentList = this.state.productAgentList;
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList;
		}
		let livechat_agent = _.find(this.state.productAgentList, (it) => it.id === this.props.access.user.loggedUserObj.extra.user_id);
		if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
			if (selectedTeam !== 'all') {
				showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedTeam);
			} else {
				showingproductAgentList2 = productAgentList;
			}
			if (livechat_agent && livechat_agent.team && !livechat_agent.team_admin) {
				if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
					showingproductAgentList2 = _.filter(this.state.productAgentList, (it) => it.team === livechat_agent.team);
				}
			} else {
				if (selectedTeam !== 'all') {
					showingproductAgentList2 = _.filter(productAgentList, (it) => it.team === selectedTeam);
				} else {
					showingproductAgentList2 = productAgentList;
				}
			}
		}
		let dropAgentList = _.map(showingproductAgentList2, function (it) {
			return { text: it.developer, key: it.id, value: it.id };
		});
		dropAgentList = _.concat({ text: t('allAgent'), key: 'all', value: 'all' }, dropAgentList);
		let watsons_groups = [
			{
				text: t('allGroups'),
				value: 'all',
				id: 'all',
				key: 'all',
			},
		];
		if (chat_groups && chat_groups.length) {
			_.each(chat_groups, (it) =>
				watsons_groups.push({
					text: it.label,
					value: it.id,
					id: it.id,
					key: it.id,
				})
			);
		}
		let teams = [
			{
				text: t('allTeams'),
				value: 'all',
				id: 'all',
				key: 'all',
			},
		];
		if (chat_teams && chat_teams.length) {
			_.each(chat_teams, (it) =>
				teams.push({
					text: it.label,
					value: it.id,
					id: it.id,
					key: it.id,
				})
			);
		}
		let ratesDropdown = [
			{
				text: '5',
				key: 5,
				value: 5,
			},
			{
				text: '4',
				key: 4,
				value: 4,
			},
			{
				text: '3',
				key: 3,
				value: 3,
			},
			{
				text: '2',
				key: 2,
				value: 2,
			},
			{
				text: '1',
				key: 1,
				value: 1,
			},
		];
		let filteredList = _.filter(list, (o) => _.includes(value, parseInt(o.rate)));
		if (search_text !== '') {
			let regex = new RegExp(search_text);
			filteredList = _.filter(filteredList, (o) => regex.test(o.cid));
		}

		filteredList = _.orderBy(filteredList, [column], [direction === 'ascending' ? 'asc' : 'desc']);
		// uzun/boşluksuz yorumlar hücreden taşmasın diye kelime kırma
		const commentCellStyle = { wordBreak: 'break-word', overflowWrap: 'anywhere', maxWidth: '300px' };
		if (loading)
			return (
				<Container>
					<Segment style={{ marginBottom: '20px' }}>
						<Page.Loader></Page.Loader>
					</Segment>
				</Container>
			);
		return (
			<Container>
				<Segment style={{ marginBottom: '20px' }}>
					<div style={{ display: 'flex' }}>
						<Dropdown
							selection
							options={platformList}
							value={selectedPlatform}
							floating
							labeled
							button
							icon="filter"
							className="icon"
							name="selectedPlatform"
							onChange={(e, { name, value }) => this.setState({ selectedPlatform: value })}
						/>
						{product &&
						product.live &&
						product.live.settings &&
						product.live.settings.analyticView &&
						product.live.settings.analyticView.watsonsgroups ? (
							<Dropdown
								selection
								options={watsons_groups}
								value={selectedWatsonsGroup}
								floating
								labeled
								button
								icon="filter"
								className="icon"
								name="selectedWatsonsGroup"
								onChange={(e, { name, value }) => this.setState({ selectedWatsonsGroup: value })}
							/>
						) : (
							''
						)}
						{product &&
						product.live &&
						product.live.settings &&
						product.live.settings.analyticView &&
						product.live.settings.analyticView.agentTeams &&
						((livechat_agent && livechat_agent.team_admin) || (livechat_agent && livechat_agent.type && livechat_agent.type === 'admin')) ? (
							<Dropdown
								selection
								options={teams}
								value={selectedTeam}
								floating
								labeled
								button
								icon="filter"
								className="icon"
								name="selectedTeam"
								onChange={(e, { name, value }) => this.setState({ selectedTeam: value })}
							/>
						) : (
							''
						)}
						<Dropdown
							options={dropAgentList}
							selection
							defaultValue={this.state.selectedAgent || dropAgentList[0].value}
							icon="filter"
							floating
							labeled
							button
							className="icon"
							onChange={this.handleFilterChange}
						></Dropdown>
						{/* <Dropdown
							options={ratesDropdown}
							selection
							defaultValue={ratesDropdown[0].value}
							icon="filter"
							floating
							labeled
							button
							className="icon"
							onChange={this.handleFilterChangeRate}
						></Dropdown> */}
						{_.map(ratesDropdown, (it, i) => (
							<Checkbox
								style={{ margin: '10px' }}
								checked={_.includes(value, it.value)}
								label={it.text}
								key={i}
								onChange={() => this.handleFilterCheck(it.value)}
							></Checkbox>
						))}
					</div>
					{/* <Form style={{ marginTop: '20px' }}>
						<Form.Input
							icon="search"
							iconPosition="left"
							placeholder={t('conversationId')}
							value={search_text}
							name="search_text"
							onChange={this.handleChange}
						/>
					</Form> */}
					<Table sortable>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>{t('name')}</Table.HeaderCell>
								<Table.HeaderCell sorted={column === 'rate' ? direction : null} onClick={this.handleSort('rate')}>
									{t('Rate')}
								</Table.HeaderCell>
								<Table.HeaderCell sorted={column === 'topic' ? direction : null} onClick={this.handleSort('topic')}>
									{t('topic')}
								</Table.HeaderCell>
								<Table.HeaderCell width={4} sorted={column === 'date' ? direction : null} onClick={this.handleSort('date')}>
									{t('date')}
								</Table.HeaderCell>
								<Table.HeaderCell sorted={column === 'platform' ? direction : null} onClick={this.handleSort('platform')}>
									{t('platform')}
								</Table.HeaderCell>
								<Table.HeaderCell
									width="5"
									sorted={column === 'selectable_comment' ? direction : null}
									onClick={this.handleSort('selectable_comment')}
								>
									{t('selectable_comment')}
								</Table.HeaderCell>
								<Table.HeaderCell width="5" sorted={column === 'comment' ? direction : null} onClick={this.handleSort('comment')}>
									{t('comment')}
								</Table.HeaderCell>
								<Table.HeaderCell width="1"></Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{_.map(filteredList, function (it) {
								let agent = _.find(productAgentList, { id: it.agent });
								let oldagent = _.find(productOldAgentList, { id: it.agent });
								let topic = _.find(closeTags, { id: it.topic });

								let displayName_2 = displayName === 'name' ? 'fullname' : 'developer';
								if (agent)
									return (
										<Table.Row>
											<Table.Cell>{(agent && (agent[displayName_2] || agent.developer)) || it.agent}</Table.Cell>
											<Table.Cell>{it.rate}</Table.Cell>
											<Table.Cell>{(topic && topic.title) || it.topic}</Table.Cell>
											<Table.Cell>{moment(it.date).format('DD-MM-YYYY')}</Table.Cell>
											<Table.Cell>
												{pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && it.platform === 'web' ? 'flo' : it.platform}
											</Table.Cell>
											<Table.Cell style={commentCellStyle}>{it.selectable_comment}</Table.Cell>
											<Table.Cell style={commentCellStyle}>{it.comment}</Table.Cell>
											<Table.Cell>
												<Button
													icon
													primary
													onClick={() => {
														const win = window.open('/#' + it.cid, '_blank');
														win.focus();
													}}
												>
													<Icon name="chat"></Icon>
												</Button>
											</Table.Cell>
										</Table.Row>
									);
								if (oldagent)
									return (
										<Table.Row>
											<Table.Cell>{'Eski-' + (oldagent && (oldagent[displayName_2] || oldagent.developer)) || it.oldagent}</Table.Cell>
											<Table.Cell>{it.rate}</Table.Cell>
											<Table.Cell>{(topic && topic.title) || it.topic}</Table.Cell>
											<Table.Cell>{moment(it.date).format('DD-MM-YYYY')}</Table.Cell>
											<Table.Cell>
												{pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && it.platform === 'web' ? 'flo' : it.platform}
											</Table.Cell>
											<Table.Cell style={commentCellStyle}>{it.selectable_comment}</Table.Cell>
											<Table.Cell style={commentCellStyle}>{it.comment}</Table.Cell>
											<Table.Cell>
												<Button
													icon
													primary
													onClick={() => {
														const win = window.open('/#' + it.cid, '_blank');
														win.focus();
													}}
												>
													<Icon name="chat"></Icon>
												</Button>
											</Table.Cell>
										</Table.Row>
									);
							})}
						</Table.Body>
					</Table>
				</Segment>
			</Container>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product });
export default connect(stateToProps)(withTranslation()(Analytic));
